import { TableSettings } from 'api/api';
import { Action } from 'redux';
import { isType } from 'typescript-fsa';
import * as actions from './actions';
import { allColumns, PredictionTableSettingsState } from './types';

export const initialState: PredictionTableSettingsState = {
	columnOrder: [
		'outerCollapsible',
		'innerCollapsible',
		'actualEmptiedDate',
		'predictedDaysUntilFull',
		'predictionDate',
		'predictedDate',
		'predictionError',
		'predictedFillLevel',
	],
	columnWidths: [
		{ columnName: 'outerCollapsible', width: 10 },
		{ columnName: 'innerCollapsible', width: 10 },
		{ columnName: 'actualEmptiedDate', width: 0 }, //Dummy column for sorting
		{ columnName: 'predictedDaysUntilFull', width: 220 },
		{ columnName: 'predictedDate', width: 155 },
		{ columnName: 'predictionDate', width: 155 },
		{ columnName: 'predictionError', width: 220 },
		{ columnName: 'predictedFillLevel', width: 150 },
	],
	columns: allColumns,
	tableSettings: new TableSettings(),
	loaded: false,
};

export function predictionTableSettingsReducer(
	state: typeof initialState = initialState,
	action: Action
): typeof initialState {
	if (isType(action, actions.setColumnOrderAction)) {
		return {
			...state,
			columnOrder: action.payload,
		};
	}
	if (isType(action, actions.setColumnSizeAction)) {
		return {
			...state,
			columnWidths: action.payload,
		};
	}

	return state;
}
